export const isLocal = import.meta.env.VITE_CLIENT_LOCAL === 'true';
export const isServerLocal = import.meta.env.VITE_LOCAL === 'true';

const redirect = isServerLocal
  ? encodeURIComponent('http://localhost:4000/discord/auth/redirect')
  : encodeURIComponent(`https://api.zoombies.world/discord/auth/redirect`);